<div class="button-close mb-2 closeButton" >
    <img src="assets/images/arrow_close.svg" [mat-dialog-close]="false">
</div>
<img [src]=data?.img class="fullscreenImage">

